// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require work_tags/_namespace

//= require_tree ./models
//= require_tree ./collections
//= require ./views

//= require_tree .
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/work_tags/_namespace.coffee')
require('sprocket-compat?this!javascripts/work_tags/models/coauthor_tag.coffee')
require('sprocket-compat?this!javascripts/work_tags/collections/coauthor_tags.coffee')
require('javascripts/work_tags/views/index.js')
require('javascripts/work_tags/templates/coauthor_tag_edit_JST.wjs.js')
require('javascripts/work_tags/templates/hover_popover_content_JST.wjs.js')
require('javascripts/work_tags/templates/invite_coauthor_modal_JST.wjs.js')
require('javascripts/work_tags/templates/suggestable_tag_JST.wjs.js')
require('sprocket-compat?this!javascripts/work_tags/views/coauthor_picker.coffee')
require('sprocket-compat?this!javascripts/work_tags/views/coauthor_tag_edit.coffee')
require('sprocket-compat?this!javascripts/work_tags/views/coauthor_tag_view.coffee')
require('sprocket-compat?this!javascripts/work_tags/views/coauthor_tags_view.coffee')
require('javascripts/work_tags/views/index.js')
require('sprocket-compat?this!javascripts/work_tags/views/invite_coauthor_modal.coffee')
require('sprocket-compat?this!javascripts/work_tags/views/paper_rank_view.coffee')
require('sprocket-compat?this!javascripts/work_tags/views/suggestable_tag_view.coffee')
require('sprocket-compat?this!javascripts/work_tags/views/suggestable_tags_view.coffee')
// MAGIC_DESPROCKET_END
